import React from 'react'

const Customer: React.FC = () => null

export default Customer
